// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"62b45b2a","845":"b3c76383"}[chunkId] + ".chunk.js";
};